import styled from "@emotion/styled";
import { GlobalSearchGalleryResultsResponse } from "@kaltura/mediaspace-shared-types";
import { Box, useTheme } from "@kaltura/mediaspace-shared-styled";
import { Link, Typography } from "@kaltura/ds-react-components";
import { translate, useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import GalleryItem from "./gallery-item/GalleryItem";

export type GallerySearchResultsProps = GlobalSearchGalleryResultsResponse;

const StyledGallerySearchResults = styled(Box)(({ theme }) => ({
    width: "100%",
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
}));

const HeadingWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "flex-end",
    marginBottom: theme.spacing(3),
}));

const StyledGalleriesList = styled("ul")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    rowGap: theme.spacing(1),
    padding: 0,
    margin: 0,
    marginLeft: theme.spacing(-2),
}));

/**
 * Galleries search results
 */
export function GallerySearchResults({ eSearchCategoryResponse, allGalleriesResultsUrl }: GallerySearchResultsProps) {
    const theme = useTheme();
    const isSmScreen = useMediaQuery(theme.breakpoints.up(theme.breakpoints.values.sm));

    const categories = eSearchCategoryResponse.objects.slice(0, isSmScreen ? 6 : 3);

    return (
        <StyledGallerySearchResults>
            <HeadingWrapper>
                <Typography component={"h2"} variant={"h5"}>
                    {translate("Gallery results")}
                </Typography>
                <Link href={allGalleriesResultsUrl} size={"small"} aria-label={translate("See all gallery results")}>
                    {translate("See all")}
                </Link>
            </HeadingWrapper>
            <StyledGalleriesList>
                {categories.map((category, ind) => (
                    <GalleryItem searchResult={category} key={`gal_${ind}`} />
                ))}
            </StyledGalleriesList>
        </StyledGallerySearchResults>
    );
}

export default GallerySearchResults;
